import { FC } from "react";
import {
  Box,
  Container,
  Typography,
  Divider,
} from "@mui/material";

import { ContactForm } from "../../components/HomePage/ContactForm/ContactForm";

export const VendingATMContactUsPage: FC = () => {
  return (
    <Box sx={{ bgcolor: "#f5f6f5", color: "#1f2a44", minHeight: "100vh", py: 8 }}>
      <Container maxWidth="md">
        {/* Title */}
        <Typography
          variant="h2"
          fontWeight={700}
          align="center"
          gutterBottom
          sx={{ mb: 4, fontSize: { xs: "2rem", md: "3rem" } }}
        >
          Contact Us
        </Typography>

        {/* Introduction */}
        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          We’re here to support your vending machine and ATM needs. Whether you have questions about installation, maintenance, or partnership opportunities, our team is ready to assist. Fill out the form below, and we’ll respond promptly—typically within the same day—with solutions tailored to your business.
        </Typography>

        <Divider sx={{ my: 4 }} />

        {/* Form Section */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography
            variant="h4"
            fontWeight={600}
            gutterBottom
            sx={{ mb: 3 }}
          >
            Get in Touch
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 4, maxWidth: 600, mx: "auto" }}
          >
            Share your details and let us know how we can help with your vending machine or ATM services. We’re committed to making your experience efficient and reliable.
          </Typography>
          <ContactForm />
        </Box>

        <Divider sx={{ my: 4 }} />
      </Container>
    </Box>
  );
};
